import TableColumnDeleteIcon from '@atlaskit/icon/core/table-column-delete';
import TableRowDeleteIcon from '@atlaskit/icon/core/table-row-delete';
import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { ActionComponent } from '../ActionComponent.tsx';
import { type Trigger, type Action, ActionPopup } from '../ActionPopup.tsx';
import { messages } from '../messages.ts';

type DeleteValueProps = {
  handleDeleteEntries: () => void;
  handleDeleteFields: () => void;
  entriesCount: number;
  fieldsCount: number;
  isDeleteColumnsDisabled: boolean;
};

export const DeleteValue = ({
  handleDeleteEntries,
  handleDeleteFields,
  entriesCount,
  fieldsCount,
  isDeleteColumnsDisabled
}: DeleteValueProps) => {
  const { formatMessage } = useIntl();

  if (isDeleteColumnsDisabled) {
    return (
      <ActionComponent
        type="delete"
        selectionMode="value"
        message={formatMessage(messages['action-bar.value-delete-entries-action'], {
          count: entriesCount
        })}
        iconBefore={
          <Box style={{ color: token('color.background.danger.pressed') }}>
            <TableRowDeleteIcon
              label={formatMessage(messages['action-bar.value-delete-entries-action'])}
              size="medium"
            />
          </Box>
        }
        onClick={handleDeleteEntries}
      />
    );
  }

  const actions: Action[] = [
    {
      type: 'delete-entry',
      message: formatMessage(messages['action-bar.value-delete-entries-action'], {
        count: entriesCount
      }),
      icon: (
        <TableRowDeleteIcon
          label={formatMessage(messages['action-bar.value-delete-entries-action'], {
            count: entriesCount
          })}
          size="medium"
        />
      ),
      onClick: handleDeleteEntries,
      shouldRender: true
    },
    {
      type: 'delete-field',
      message: formatMessage(messages['action-bar.value-delete-fields-action'], {
        count: fieldsCount
      }),
      icon: (
        <TableColumnDeleteIcon
          label={formatMessage(messages['action-bar.value-delete-fields-action'], {
            count: fieldsCount
          })}
          size="medium"
        />
      ),
      onClick: handleDeleteFields,
      shouldRender: true
    }
  ];

  const trigger: Trigger = {
    type: 'delete',
    message: formatMessage(messages['action-bar.value-delete-action']),
    icon: (
      <Box style={{ color: token('color.background.danger.pressed') }}>
        <TableColumnDeleteIcon
          label={formatMessage(messages['action-bar.value-delete-action'])}
          size="medium"
        />
      </Box>
    ),
    selectionMode: 'value'
  };

  return <ActionPopup actions={actions} trigger={trigger} />;
};
